import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { apiUrl, middlewareUrl } from '@app/app.constants';
import { UserLevel } from '@app/core/models/user-level';
import { NotificationService } from '@app/core/services/notification.service';
import { CommandDefinition, CommandHelper, QuickCommandService } from '@app/shared/quick-commands';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApplicationMaintenanceCommand {
  private http = inject(HttpClient);
  private notificationService = inject(NotificationService);

  getCommand(): CommandDefinition<['reload' | 'clearCache']> {
    return {
      authorization: {
        requiredUserLevel: environment.production ? UserLevel.SystemAdmin : UserLevel.All,
      },
      icon: 'far fa-power-off',
      label: 'quickCommands.commands.reloadApplication',
      name: 'reloadApplication',
      section: QuickCommandService.DevSection,

      action: (_, [type]) => {
        if (type === 'reload') {
          this.notificationService
            .showLoadingToast(this.http.put(apiUrl(`/reloadApplication`), { responseType: 'text' }), {
              error: 'quickCommands.commands.reloadApplication.reload.failed',
              loading: 'quickCommands.commands.reloadApplication.reload',
              success: 'quickCommands.commands.reloadApplication.reload.success',
            })
            .subscribe();

          return CommandHelper.close();
        } else if (type === 'clearCache') {
          this.notificationService
            .showLoadingToast(
              this.http.get(middlewareUrl(`/branding/clearCacheForAll`), {
                responseType: 'text',
              }),
              {
                error: 'quickCommands.commands.reloadApplication.clearCache.failed',
                loading: 'quickCommands.commands.reloadApplication.clearCache',
                success: 'quickCommands.commands.reloadApplication.clearCache.success',
              }
            )
            .subscribe();

          return CommandHelper.close();
        }

        return CommandHelper.list({
          filterAutomatically: true,
          sort: 'asc',
          values: [
            {
              label: 'quickCommands.commands.reloadApplication.reload',
              value: 'reload',
            },
            {
              label: 'quickCommands.commands.reloadApplication.clearCache',
              value: 'clearCache',
            },
          ],
        });
      },
    };
  }
}
